import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";

const reportUrls = {
  EGM: "https://app.powerbi.com/view?r=eyJrIjoiMTMwMGZhMzItNDliNy00ODlhLTkzZDAtZGU0NmMyMGRhMjVhIiwidCI6IjBlNTI1YjNlLTc2NTgtNGI2Zi1hYmJkLTU5N2E4M2UwYzMxNiIsImMiOjl9&pageName=a4eb092084a8011cdc0c",
  EGM1: "https://app.powerbi.com/view?r=eyJrIjoiMGM1MzU1ODYtMmQwOC00ZDgwLTg5ODItN2RjZjNiYTVmOGVhIiwidCI6IjBlNTI1YjNlLTc2NTgtNGI2Zi1hYmJkLTU5N2E4M2UwYzMxNiIsImMiOjl9",
};

const Factory = () => {
  const [activeReportKey, setActiveReportKey] = useState(null);

  const links = [
    { name: "EGM (Export General Manifest) Tracking", key: "EGM", internal: true },
    { name: "Daily Dispatch", url: "https://example.com/inventory-report" },
    { name: "Vessel Schedule Dashboard", url: "https://example.com/finance-report" },
    { name: "Detention Charges", url: "https://example.com/finance-report" },
    { name: "Ground Rent Charges", url: "https://example.com/feedback" },
    { name: "Factory Delivery Analysis", url: "https://example.com/analytics" },
    { name: "Landscape (Product) Performance Report", key: "EGM1", internal: true },
  ];

  const handleClick = (link) => {
    if (link.internal && link.key in reportUrls) {
      setActiveReportKey(link.key);
    } else if (link.url) {
      window.open(link.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleBack = () => setActiveReportKey(null);

  if (activeReportKey && reportUrls[activeReportKey]) {
    return (
      <div style={{ margin: "10px" }}>
        <Button
          variant="secondary"
          onClick={handleBack}
          style={{ marginBottom: "15px" }}
        >
          &lt; Back to Reports
        </Button>
        <div style={{ width: "100%", height: "100vh" }}>
          <iframe
            title="Power BI Report"
            width="100%"
            height="100%"
            src={reportUrls[activeReportKey]}
            allowFullScreen
            style={{ border: "none" }}
          ></iframe>
        </div>
      </div>
    );
  }

  return (
    <div style={{ margin: "10px" }}>
      <h5 className="mb-3">Factory Reports</h5>
      <Table bordered size="sm" className="text-center align-middle">
        <thead className="table-light">
          <tr>
            <th style={{ width: "5%" }}>#</th>
            <th style={{ textAlign: "left" }}>Report Name</th>
            <th style={{ width: "10%" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {links.map((link, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td style={{ textAlign: "left" }}>{link.name}</td>
              <td>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleClick(link)}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Factory;
